import {Component, EventEmitter, Input, Output} from '@angular/core';


@Component({
  selector: 'app-description-panel',
  standalone: true,
  imports: [],
  templateUrl: './description-panel.component.html',
  styleUrls: ['./description-panel.component.scss']
})
export class DescriptionPanelComponent {
  @Input() currentDescription: string = '';
  @Input() isLoadingAlternatives: boolean = false;
  @Input() hasAudioResults: boolean = false;
  @Output() refreshAlternativePrompt = new EventEmitter<void>();

  onRefreshClick() {
    if (!this.isLoadingAlternatives) {
      this.refreshAlternativePrompt.emit();
    }
  }
}
